<template>
  <div class="transition">
    <BasicText size="h5">
      Renseignez les informations disponibles sur le courrier
    </BasicText>
    <div class="transition-items">
      <WrapperInput
        v-if="props.in === 'adherent'"
        v-model="code"
        label="Code d'activation adhérent"
        placeholder="Code d'activation à 6 caractères"
        :maxlength="6"
      />
      <WrapperInput
        v-else
        v-model="code"
        label="Code d'activation prestataire de formation"
        placeholder="Code d'activation à 6 caractères"
        :maxlength="6"
      />
      <BasicAlert
        alert-type="info"
        alert-label="Code de 6 caractères comportant des lettres et des chiffres."
      />
    </div>
    <div class="transition-items">
      <WrapperInput
        v-model="sirenSiret"
        label="SIREN ou SIRET correspondant au code"
        placeholder="123456789 ou 12345678901234"
        :maxlength="14"
      />
      <BasicAlert
        alert-type="info"
        alert-label="SIREN ou SIRET tel qu’il est indiqué sur le courrier."
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import type { DemandeRattachementResult } from '../types'
  import type { ContextAppType } from '@/features/auth/context-app'
  import { isSiren, isSiret } from '@/features/shared/tools/luhn'

  type In = ContextAppType
  type Out = Pick<DemandeRattachementResult, 'code' | 'codeSirenSiret'>

  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const code = computed({
    get: () => props.out?.code,
    set: (value) => {
      const model = {
        code: (value ?? '').toUpperCase(),
        codeSirenSiret: sirenSiret.value ?? '',
      }
      emits('outChanged', estSirenValide(sirenSiret.value) && estCodeValid(value), model)
    },
  })

  const sirenSiret = computed({
    get: () => props.out?.codeSirenSiret,
    set: (value) => {
      const model = {
        code: code.value,
        codeSirenSiret: value ?? '',
      }
      emits('outChanged', estSirenValide(value) && estCodeValid(code.value), model)
    },
  })

  const estCodeValid = (code?: string) => (code ?? '').trim().length === 6
  const estSirenValide = (sirenOuSiret?: string) => {
    sirenOuSiret = sirenOuSiret?.trim() ?? ''
    if (sirenOuSiret.length === 9) {
      return isSiren(sirenOuSiret)
    } else if (sirenOuSiret.length === 14) {
      return isSiret(sirenOuSiret)
    }
    return false
  }
</script>

<style lang="less" scoped>
  @import './ChoixCarte.less';
  .icon {
    transform: scale(2);
    margin: 24px;
  }
</style>
